/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-monitor';
const componentName = 'radius-health-monitor-config';
const prefix = `${moduleName}.${componentName}`;

export const sectionTitleRadius = `${prefix}.sectionTitleRadius`;
export const sharedSecretInputLabel = `${prefix}.sharedSecretInputLabel`;
export const sharedSecretInputPlaceholder = `${prefix}.sharedSecretInputPlaceholder`;

export const ENGLISH = {
    [sectionTitleRadius]: 'Radius',
    [sharedSecretInputLabel]: 'Shared Secret',
    [sharedSecretInputPlaceholder]: 'Enter Shared Secret',
};
